import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-success-notification',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './success-notification.component.html',
  styleUrl: './success-notification.component.css'
})
export class SuccessNotificationComponent {
  title = 'Success!';
  iconClass = 'success';

  constructor(
    public dialogRef: MatDialogRef<SuccessNotificationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string; duration?: number; type?: string }
  ) {
    // Determine title and style based on notification type
    if (this.data?.type === 'deleted') {
      this.title = 'Deleted!';
      this.iconClass = 'deleted';
    } else if (this.data?.type === 'error') {
      this.title = 'Error!';
      this.iconClass = 'error';
    } else if (this.data?.type === 'info') {
      this.title = 'Info';
      this.iconClass = 'info';
    } else if (this.data?.type === 'toyota-info') {
      this.title = 'Info';
      this.iconClass = 'toyota-info';
    }

    // Keep legacy auto-close behavior for existing notifications.
    if (this.data?.duration !== 0) {
      setTimeout(() => {
        this.dialogRef.close();
      }, 4000);
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }
}

